import { resources } from 'redux-and-the-rest';

import { GameModel } from '../../models/gameModel';
import Env from '../../utils/env';
import { userActions } from './userReducer';

const {
  reducers: gamesReducer,
  fetchList: fetchGames,
  getOrFetchItem: getOrFetchGame,
  getOrFetchList: getOrFetchGames,
} = resources<GameModel>(
  {
    name: 'game',
    url: `${Env.API_URL}/games/:id?`,
    keyBy: 'id',
    clearOn: [
      userActions.clearItem as string,
    ],
  },
  {
    fetchList: true,
    fetchItem: true,
  },
);

export {
  gamesReducer,
  fetchGames,
  getOrFetchGame,
  getOrFetchGames,
};
